class BaoBannerVideo extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['video']
  }

  connectedCallback () {
    super.connectedCallback()

    this.loadVideo()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.observer?.disconnect()
  }

  setupListeners () {
    super.setupListeners()

    if (!('IntersectionObserver' in window)) return

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      threshold: 0.1,
    })
    this.observer.observe(this.els.video.element)
  }

  loadVideo () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const isDesktop = window.matchMedia('(min-width: 750px)').matches
    const src = this.dataset[isDesktop ? 'desktopMp4Src' : 'mobileMp4Src']
    const type = this.dataset[isDesktop ? 'desktopMp4Type' : 'mobileMp4Type']

    if (!src) return

    const video = this.els.video.element
    const sourceEl = document.createElement('source')
    sourceEl.src = src
    if (type) sourceEl.type = type
    video.appendChild(sourceEl)

    this.listeners.add(
      video,
      'canplay',
      () => video.classList.add('is-loaded'),
      { once: true },
    )

    video.load()
    video.play().catch(() => {})
  }

  onIntersect (entries) {
    const video = this.els.video.element

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        video.play().catch(() => {})
      } else {
        video.pause()
      }
    })
  }
}

if (!customElements.get('bao-banner-video')) {
  customElements.define('bao-banner-video', BaoBannerVideo)
}
